export const GOOGLE_BUSINESS_CONNECTION_STATE = {
  not_started: "not_started",
  connected: "connected",
} as const;

export const GOOGLE_BUSINESS_ACCOUNT_STATUS = {
  active: "active",
  pending: "pending",
  error: "error",
} as const;

export const SERVICE_TITAN_STATUSES = {
  awaiting_tenant_id: "awaiting_tenant_id",
  tenant_id_received: "tenant_id_received",
  ready_for_credentials: "ready_for_credentials",
  credentials_received: "credentials_received",
  connection_established: "connection_established",
  business_churned: "business_churned",
} as const;

export const PAY_PERIOD_TEMPLATE_CADENCE = {
  weekly: "weekly",
  monthly: "monthly",
  every_other_week: "every_other_week",
  first_and_fifteenth: "first_and_fifteenth",
} as const;

export const PAY_PERIOD_TEMPLATE_START_DAY_OF_WEEK = {
  monday: "monday",
  tuesday: "tuesday",
  wednesday: "wednesday",
  thursday: "thursday",
  friday: "friday",
  saturday: "saturday",
  sunday: "sunday",
} as const;

export const WORKBOOK_ACCESS_MODES = {
  unconfigured: "unconfigured",
  full: "full",
  scoped: "scoped",
  none: "none",
} as const;

export const BUSINESS_QUERY_KEYS = {
  currentUserWorkbookAccess: "current-user-workbook-access",
} as const;
